import ArticleVariantResourceModel from '../../generated/types/model/resource/ArticleVariantResourceModel';

export default class ArticleVariantResourceViewModel extends ArticleVariantResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
